import api from "../../api/services/axiosService";
import { DOCTOR_TATVA } from "../../envConstants";

const baseUrl: any = { customBaseUrl: DOCTOR_TATVA };

export const sendOTP = async function (payload: any) {
  let res = {};
  try {
    res = await api.post(`/api/v1/onboarding/otp/send`, payload, baseUrl);
  } catch (e) {
    console.error("Error while sending otp: ", e);
  }
  return res;
};

export const resendOTP = async function (payload: any) {
  let res = {};
  try {
    res = await api.post(`/api/v1/onboarding/otp/resend`, payload, baseUrl);
  } catch (e) {
    console.error("Error while resending otp: ", e);
  }
  return res;
};

export const validateOTP = async function (payload: any) {
  let res = {};
  try {
    res = await api.post(`/api/v1/onboarding/otp/verify`, payload, baseUrl);
  } catch (e) {
    console.error("Error while validating otp: ", e);
  }
  return res;
};

export const register = async function (payload: any) {
  let res = {};
  try {
    res = await api.post(`/api/v1/onboarding/register`, payload, baseUrl);
  } catch (e) {
    console.error("Error while registering: ", e);
  }
  return res;
};

export const login = async function (payload: any) {
  let res = {};
  try {
    res = await api.post(`/api/v1/onboarding/login`, payload, baseUrl);
  } catch (e) {
    console.error("Error while logging: ", e);
  }
  return res;
};

